import { TableColumn } from "..";

export function getDefaultSortBy<TRecord>(columns: TableColumn<TRecord>[]): TableColumn<TRecord>["field"] {
  if (!columns.length) return "";
  if (columns.some((column) => column.field === "to_date")) return "to_date";

  return columns[0].field;
}
